import { IMappedData } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/IMappedData";

export function GetMovingAverage(
    data: IMappedData[],
    windowSize: number
): IMappedData[] {
    const movingAverageData: IMappedData[] = [];

    for (let i = 0; i < data.length; i++) {
        // Get the subset of data for the current window
        const window = data.slice(Math.max(0, i - windowSize + 1), i + 1);

        // Calculate the average value for the window
        const averageValue = window.reduce((sum, item) => sum + item.value, 0) / window.length;

        // Push the averaged data into the result array
        movingAverageData.push({
            time: data[i].time,
            value: averageValue,
        });
    }

    return movingAverageData;
}
